import { type FC } from 'react'
import { Outlet, useMatch } from 'react-router-dom'

import { Spinner } from '@factorialco/deprecated-design-system'
import { ViewProcessesDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

export const Component: FC = () => {
  const { navigation } = useNavigation()

  const isSurveysRoute = !!useMatch(`${navigation.processes.surveys.fullPath()}/*`)

  const { loading, data } = useQuery(ViewProcessesDocument, { skip: isSurveysRoute })

  if (isSurveysRoute) return <Outlet />
  if (loading) return <Spinner />

  const canViewProcesses = () => Boolean(data?.processes._policies.processEditProcesses.can)

  return (
    <AuthorizeUser authorizeFn={canViewProcesses}>
      <Outlet />
    </AuthorizeUser>
  )
}
